/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAnalyticEventInviteCreatedFromJSON(json) {
    return StreemApiAnalyticEventInviteCreatedFromJSONTyped(json, false);
}
export function StreemApiAnalyticEventInviteCreatedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inviteSid': !exists(json, 'invite_sid') ? undefined : json['invite_sid'],
        'method': !exists(json, 'method') ? undefined : json['method'],
        'successful': !exists(json, 'successful') ? undefined : json['successful'],
    };
}
export function StreemApiAnalyticEventInviteCreatedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'invite_sid': value.inviteSid,
        'method': value.method,
        'successful': value.successful,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiAnalyticEventInviteCreatedMethod;
(function (StreemApiAnalyticEventInviteCreatedMethod) {
    StreemApiAnalyticEventInviteCreatedMethod["EMAIL"] = "DELIVERY_TYPE_EMAIL";
    StreemApiAnalyticEventInviteCreatedMethod["INVALID"] = "DELIVERY_TYPE_INVALID";
    StreemApiAnalyticEventInviteCreatedMethod["LINK"] = "DELIVERY_TYPE_LINK";
    StreemApiAnalyticEventInviteCreatedMethod["SMS"] = "DELIVERY_TYPE_SMS";
})(StreemApiAnalyticEventInviteCreatedMethod || (StreemApiAnalyticEventInviteCreatedMethod = {}));
//# sourceMappingURL=StreemApiAnalyticEventInviteCreated.js.map